import { UpdateCareerSectionOrderReq } from '../dto/ReqDtoRepository';
import { AboutPageSettingResponse } from '../dto/ResDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';

export const getAboutPageSetting = async (
  aui: string,
): Promise<AboutPageSettingResponse> => {
  return sendGetApiRequest<AboutPageSettingResponse>(
    `/api/v1/about/setting?aui=${aui}`,
  );
};

export const updateCareerSectionOrder = async (
  aui: string,
  data: UpdateCareerSectionOrderReq,
): Promise<AboutPageSettingResponse> => {
  return sendApiRequest<AboutPageSettingResponse>(
    'put',
    `/api/v1/about/setting/career-section-order?aui=${aui}`,
    data,
  );
};
